import { Box } from "@mui/material";
import { ReactNode } from "react";

interface AppContainerProps {
  children: ReactNode;
}

const AppContainer = ({ children }: AppContainerProps) => {
  return (
    <Box
      className="app"
      sx={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/imgs/page-turner.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: {
          xs: "35%",
          sm: "20%",
        },
        backgroundPosition: {
          xs: "left calc(7vh + 10px)",
          sm: "left calc(5vh + 10px)",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default AppContainer;
